import {createScopedUseRegle} from '@regle/core';
import type {ActivityLocationResource, AddressResource} from '~/types/api-raw-types';
import type {LanguageAndLevel} from '~/types/domain/Languages';
import {type LanguageLevel} from '~/types/domain/Languages';
import type {IndustryExpertiseItem} from '~/types/domain/skill/Industry';

export const {useScopedRegle: useScopedRegleItem, useCollectScope: useCollectScopeRecord} = createScopedUseRegle({asRecord: true});

export type IndustryExpertiseEditionItem = {
    humanId: string;
    label: string;
};

export type LanguageEditionItem = {
    name: string;
    code: string;
    level: LanguageLevel;
};

export type AlternativeAddressEditionItem = {
    address: AddressResource;
    radius: number;
};

export type TravelLocationEditionItem = {
    value: string;
};

export function toIndustryExpertiseEditionItem(industryExpertise: IndustryExpertiseItem): IndustryExpertiseEditionItem {
    return {
        humanId: industryExpertise.id,
        label: industryExpertise.label,
    };
}

export function toLanguageEditionItem(item: LanguageAndLevel): LanguageEditionItem {
    return {
        name: item.language.name,
        code: item.language.code,
        level: item.level,
    };
}

export function toAlternativeAddress(item: ActivityLocationResource): AlternativeAddressEditionItem {
    return {
        address: {
            administrativeAreaLevel1: item.address.administrativeAreaLevel1,
            administrativeAreaLevel1Code: item.address.administrativeAreaLevel1Code,
            administrativeAreaLevel2: item.address.administrativeAreaLevel2,
            administrativeAreaLevel2Code: item.address.administrativeAreaLevel2Code,
            administrativeAreaLevel3: item.address.administrativeAreaLevel3,
            administrativeAreaLevel3Code: item.address.administrativeAreaLevel3Code,
            administrativeAreaLevel4: item.address.administrativeAreaLevel4,
            administrativeAreaLevel4Code: item.address.administrativeAreaLevel4Code,
            formattedAddress: item.address.formattedAddress,
            street: item.address.street,
            street2: item.address.street2,
            zipCode: item.address.zipCode,
            city: item.address.city,
            country: item.address.country,
            countryCode: item.address.countryCode,
            region: item.address.region,
            loc: {
                lat: item.address.loc.lat,
                lon: item.address.loc.lon,
            },
        },
        radius: item.radius,
    };
}

export function toTravelLocationEditionItem(travelLocation: string): TravelLocationEditionItem {
    return {
        value: travelLocation,
    };
}
